import React, { useState, useEffect } from "react";
import "./style.css";

const Captcha = ({ onCaptchaChange }) => {
  const [captcha, setCaptcha] = useState({ problem: "", answer: 0 });
  const [userAnswer, setUserAnswer] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    setIsCorrect(false);
    setErrorMsg("");
    let num1, num2, operation, answer;

    do {
      num1 = Math.floor(Math.random() * 10) + 1;
      num2 = Math.floor(Math.random() * 10) + 1;
      operation = getRandomOperation();

      if (operation === "subtract" || operation === "divide") {
        [num1, num2] = [Math.max(num1, num2), Math.min(num1, num2)];
      }

      answer = calculateAnswer(num1, num2, operation);
    } while (!Number.isInteger(answer));

    const problem = `${num1} ${getOperationSymbol(operation)} ${num2}`;
    setCaptcha({ problem, answer });
  };

  const calculateAnswer = (num1, num2, operation) => {
    switch (operation) {
      case "add":
        return num1 + num2;
      case "subtract":
        return num1 - num2;
      case "multiply":
        return num1 * num2;
      case "divide":
        return num1 / num2;
      default:
        return num1 + num2;
    }
  };

  const getRandomOperation = () => {
    const operations = ["add", "subtract", "multiply", "divide"];
    const randomIndex = Math.floor(Math.random() * operations.length);
    return operations[randomIndex];
  };

  const getOperationSymbol = (operation) => {
    switch (operation) {
      case "add":
        return "+";
      case "subtract":
        return "-";
      case "multiply":
        return "*";
      case "divide":
        return "/";
      default:
        return "+";
    }
  };

  const checkAnswer = () => {
    if (parseInt(userAnswer, 10) === captcha.answer) {
      setIsCorrect(true);
    } else {
      setErrorMsg("Invalid captcha answer. Please try again.");
    }
  };

  useEffect(() => {
    onCaptchaChange(isCorrect);
  }, [isCorrect, onCaptchaChange]);

  return (
    <div className="captcha">
      {isCorrect ? (
        <p className="captcha-correct">
          Captcha: {captcha.problem}= {captcha.answer} &#10004;
        </p>
      ) : (
        <div>
          <label className="captcha-label">Captcha: {captcha.problem} =</label>
          <input
            type="text"
            value={userAnswer}
            onChange={(e) => setUserAnswer(e.target.value)}
            required
          />
          <button onClick={checkAnswer}>Submit</button>
          {errorMsg && <p className="captcha-error">{errorMsg}</p>}
        </div>
      )}
    </div>
  );
};

export default Captcha;
